export const WISHLIST_ADD_ITEM = 'WISHLIST_ADD_ITEM';
export const WISHLIST_REMOVE_ITEM = 'WISHLIST_REMOVE_ITEM';
export const WISHLIST_SET_ITEMS = 'WISHLIST_SET_ITEMS';
export const CLEAR_WISHLIST= 'CLEAR_WISHLIST';
